var flickity = require('flickity'),
    formValidation = require('formValidation'),
    loader = require('loader'),
    clubService = require('clubService'),
    wordCount = require('wordCount');

var createClub = (function() {
    var $slider = $('.flickity-carousel-outer');
    var $form = $('#create-a-club');

    var formValidation = function() {
        $form.validate({
            ignore: ":hidden",
            onsubmit: true,
            rules: {
                club_name: {
                    required: true
                },
                club_bio: {
                    maxlength: 3000
                },
            },
            submitHandler: function() {

            }
        });
    };


    var nextBtn = function() {
        $('.btn.next ').on("click", function(e) {
            e.preventDefault();
            if($form.valid() === true) {
                var step = $('.flickity-carousel-item.is-selected').attr("data-step");
                progressBar(step);
                $slider.flickity('next');
            } else {
                $form.valid();
            }
        });
    };


    var prevBtn = function() {
        $('.btn.prev').on("click", function(e) {
            e.preventDefault();
            $slider.flickity('previous');
        });
    };


    var progressBar = function(step) {
        $(".progress-bar #" + step).addClass('passed').next().addClass('fill');
    };


    var createCarousel = function() {
        $slider.flickity({
            adaptiveHeight: true,
            imagesLoaded: true,
            wrapAround: true,
            prevNextButtons: false,
            draggable: false,
            freeScroll: true
        });
    };


    var createClubBtn = function() {
        $('body').on('click', '#create-club-button', function(e) {
            e.preventDefault();
            $('window').showLoader();
            var item = {};
            // Basic Information
            item.clubName = $('#club_name').val();
            item.clubBio = $('#club_bio').val();
            // Location
            item.clubAddressLine1 = $('#club_address_line1').val();
            item.clubAddressLine2 = $('#club_address_line2').val();
            item.clubAddressCity = $('#club_address_city').val();
            item.clubAddressPostcode = $('#club_address_postcode').val();
            item.clubAddressCountry = $('#club_location').val();
            item.clubAddressCountryCode = $('#club_location_country_code').text();
            // Social Media
            item.clubFacebook = $('#club_facebook').val();
            item.clubTwitter = $('#club_twitter').val();
            item.clubInstagram = $('#club_instagram').val();
            item.clubWebsite = $('#club_website').val();
            // Club Colours
            item.clubColourPrimary = $('#primary-colours').val();
            item.clubColourSecondary = $('#secondary-colours').val();

            var data = JSON.stringify(item);
            createClubService(data, successFn, errorFn);
        });
    };


    var successFn = function(response) {
        var redirect = '/locker/';
        if(response.statusCode === 200) {
            $('window').notification({
                title: response.message
            });
            window.location.href = redirect;
        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var errorFn = function(response) {
        $('window').notification({
            title: 'Error 500 - cannot communicate with server',
            error: true
        });
    };


    var init = function() {
        formValidation();
        nextBtn();
        prevBtn();
        createCarousel();
        createClubBtn();

        var elem = $("#counter");
        $("#club_bio").limiter(3000, elem);
    };


    return {
        init: init
    };

})();

if($('#create-a-club').length) {
    createClub.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/create-club.js